import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import Ceo from '../../assets/images/ceo.jpg';
import SERV from '../../assets/images/service4.jpg';
import { motion } from 'framer-motion'; // Importation de Framer Motion

const ServicePageConcierge = () => {
  return (
    <section id="main-container" className="main-container" style={{ backgroundImage: 'url(images/assets/ban4.jpg)' }}>
      <div className="container">
        <div className="row">
          <div className="col-xl-3 col-lg-4">
            <div className="sidebar sidebar-left">
              <div className="widget">
                <h3 className="widget-title">Solutions</h3>
                <ul className="nav service-menu">
                  <li ><Link to="/Securite-residentielle-industrielle">Sécurité résidentielle et industrielle</Link></li>
                  <li><Link to="/Protection-rapprochee">Protection rapprochée</Link></li>
                  <li ><Link to="/Surveillance-de-sites-minierse">Surveillance de sites miniers</Link></li>
                  <li className="active"><Link to="/Transport-securise">Transport sécurisé</Link></li>
                 
                </ul>
              </div>

              <div className="widget">
                <div className="quote-item quote-border">
                  <div className="quote-text-border">
                   L’excellence au service de votre protection. 
                  </div>
                  <div className="quote-item-footer">
                    <img className="testimonial-thumb" src={Ceo} alt="testimonial" />
                    <div className="quote-item-info">
                      <h3 className="quote-author text-dark">Kanku Kalala Pierre</h3>
                      <span className="quote-subtext">Administrateur Général <br /> et Associé Unique</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-8 col-lg-8">
            <div className="content-inner-page">
              {/* Titre avec animation */}
              <motion.h2
                className="column-title mrt-0 fw-bold"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
              >
          Transport sécurisé
              </motion.h2>

              <div className="row">
                 <div className="col-md-12">
                  <div className="card mb-4" >
  <img src={SERV} className="card-img-top img-fluid hover-shadow" alt="Sunset Over the Sea"/>
 
</div>
                 </div>
                <div className="col-md-12">
                  {/* Paragraphe animé */}
                  <motion.p
                    className="text-left"
                    style={{ fontFamily: 'Times', fontSize: '20px' }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5, duration: 1 }}
                  >
             Le service de transport sécurisé proposé par GEKAS Security and Consulting SARL vise à garantir la sécurité des personnes, des biens sensibles et des fonds lors de leurs déplacements sur tout le territoire national. Dans un contexte marqué par l’insécurité routière, les risques de braquage et les tensions ponctuelles, nous mettons à disposition des solutions fiables pour assurer chaque trajet en toute sérénité.
                  </motion.p>
                  <motion.p
                    className="text-left"
                    style={{ fontFamily: 'Times', fontSize: '20px' }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1, duration: 1 }}
                  >
              Nos véhicules sont équipés de dispositifs de sécurité avancés (systèmes GPS, communications cryptées, blindage selon les besoins) et accompagnés de chauffeurs et agents de sécurité formés aux techniques de conduite défensive et à la gestion des situations de crise. Qu’il s’agisse de transferts de personnalités, de transport de valeurs ou de missions stratégiques, chaque opération est planifiée avec rigueur pour minimiser tout risque.
                  </motion.p>

                   <motion.p
                    className="text-left"
                    style={{ fontFamily: 'Times', fontSize: '20px' }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1, duration: 1 }}
                  >
             En choisissant GEKAS, vous optez pour une logistique sécuritaire professionnelle, ponctuelle et confidentielle. Notre approche sur mesure tient compte des réalités locales et des exigences spécifiques de chaque client, avec pour priorité la prévention, la réactivité et la discrétion. Nous faisons du transport sécurisé un maillon essentiel de votre chaîne de confiance.


                  </motion.p>
                </div>
              </div>

              <div className="gap-40"></div>

       

              <div className="gap-40"></div>

         

              <div className="gap-40"></div>

              {/* Call to Action avec animation sur le bouton */}
              <div className="call-to-action classic">
                <div className="row align-items-center">
                  <div className="col-md-8 text-center text-md-left">
                    <div className="call-to-action-text">
                      <h4 className="action-title">Êtes-vous intéressé par ce service ?</h4>
                    </div>
                  </div>
                  <div className="col-md-4 text-center text-md-right mt-3 mt-md-0">
                    <motion.div
                      className="call-to-action-btn"
                      whileHover={{ scale: 1.1, color: '#ffffff', backgroundColor: '#ff9800' }}
                    >
                      <Link to="/Contact" className="btn btn-warning">
                        Contactez-nous
                      </Link>
                    </motion.div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ServicePageConcierge;
